import React from 'react';

import { StorePage } from '@modules/store/StorePage';
import { AuthPage } from '@modules/auth';
import { UILabPage } from '@modules/uilab';
import { SnomedPage } from '@modules/snomed';
import { AccountingPage } from '@modules/accounting/AccountingPage/AccountingPage';

export interface Location {
    url: string;
    Component: React.ComponentType<any>;
}

export const locations: Location[] = [
    {
        url: '/login',
        Component: AuthPage,
    },
    {
        url: '/store',
        Component: StorePage,
    },
    {
        url: '/uilab',
        Component: UILabPage,
    },
    {
        url: '/snomed',
        Component: SnomedPage,
    },
    {
        url: '/accounting',
        Component: AccountingPage,
    },
];
